module.exports = __webpack_public_path__ + "img/hyl_bg.73bacdd9.jpg";